import { useState } from "react";
import { PhoneCall, MessageSquare, RefreshCw } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";

const FILTERS = ["all", "received", "searching", "replied", "not_found"];

const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString();
};

export const RequestsFeed = ({ requests, onSelect, onRefresh, filter, setFilter }) => {
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-lg border border-white/10 bg-[#111723]">
      <div className="flex items-center justify-between border-b border-white/10 p-4">
        <div>
          <h3 className="font-display text-lg font-bold text-slate-50">Incoming Requests</h3>
          <p className="mt-0.5 text-xs text-slate-400">Live WhatsApp case queries from lawyers</p>
        </div>
        <Button
          data-testid="refresh-requests-button"
          variant="ghost"
          size="sm"
          onClick={onRefresh}
          className="text-slate-400 hover:bg-slate-800 hover:text-white"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>

      <div className="flex flex-wrap gap-2 border-b border-white/10 p-3">
        {FILTERS.map((f) => (
          <button
            key={f}
            data-testid={`filter-${f}`}
            onClick={() => setFilter(f)}
            className={`rounded-full px-3 py-1 text-xs font-medium capitalize transition-colors duration-200 ${
              filter === f
                ? "bg-blue-600 text-white"
                : "bg-[#0B0F17] text-slate-400 hover:bg-slate-800 hover:text-white"
            }`}
          >
            {f.replace("_", " ")}
          </button>
        ))}
      </div>

      <div className="flex-1 divide-y divide-white/5 overflow-y-auto" data-testid="requests-list">
        {requests.length === 0 && (
          <div className="flex h-40 items-center justify-center">
            <p className="text-sm text-slate-500">No requests yet. Try the simulator.</p>
          </div>
        )}
        {requests.map((r) => (
          <button
            key={r.id}
            data-testid={`request-row-${r.id}`}
            onClick={() => onSelect(r)}
            className="block w-full px-4 py-3 text-left transition-colors duration-200 hover:bg-[#1A2234]"
          >
            <div className="flex items-center justify-between gap-2">
              <span className="font-mono-data text-sm font-semibold text-blue-400">{r.case_number}</span>
              <StatusBadge status={r.status} pulse />
            </div>
            <div className="mt-1.5 flex items-center gap-3 text-xs text-slate-400">
              <span className="flex items-center gap-1">
                <PhoneCall className="h-3 w-3" /> {r.lawyer_name || r.from_number}
              </span>
              <span className="font-mono-data">{r.from_number}</span>
              <span className="ml-auto">{timeAgo(r.created_at)}</span>
            </div>
            <div className="mt-1 flex items-center gap-1.5 text-xs text-slate-500">
              <MessageSquare className="h-3 w-3 shrink-0" />
              <span className="truncate">{r.inbound_message}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
